import React, { Component, Fragment } from 'react';
import Translation from "../../../../shared/Translation";
class ConfirmationLivestream extends Component {
    render() {
        if (this.props.streamData !== Object(this.props.streamData) || !Object.keys(this.props.streamData).length) {
            return null;
        }
        return (
            <div id="confirmation--live-stream">
              <div className="live-stream__info"><Translation>{'checkout__livestream_links_access_codes_listed_below'}</Translation></div>
                {Object.values(this.props.streamData).map((eventDataLivestreams, key) => {
                    return (
                        <div className="live-stream__header-event-container" key={key}>
                            <div className="live-stream__header-event-title">{eventDataLivestreams.event_name}</div>
                            {this.renderStreamData(eventDataLivestreams.livestreams_details)}
                        </div>
                    )
                })}
            </div>
        )
    }
    renderStreamData = (eventLivestreamDetails) => {
        let children = [];
        Object.values(eventLivestreamDetails).map((livestreamDetails, livestreamId) => {
            children.push(
                <Fragment key={livestreamId}>
                    {this.renderCodes(livestreamDetails.codes, livestreamDetails.url, livestreamDetails.stream_name, livestreamDetails.link_text)}
                </Fragment>
            )
        })
        return children;
    }

    renderCodes = (codes, url, title, linkText) => {
        let children = [];
        codes.map((accessCode, key) => {
            children.push(
                <div className="live-stream__container" key={key}>
                    <div className="live-stream__code-container" key={`${key}code`}>
                        <div className="live-stream__code-title">{title}</div>
                        <div className="live-stream__code">{accessCode.code}</div>
                    </div>
                    <div className="live-stream__button-container" key={`${key}link`}>
                        <a href={`${url}/${accessCode.code}`} className="button--primary live-stream__button">
                            <span className="livestream__button--icon">
                                <i className="icon-videocam" aria-hidden="true"></i>
                                <span className="sr-only"><Translation>{'checkout__livestream_code'}</Translation></span>
                            </span>
                            {linkText}
                        </a>
                    </div>
                </div>
            )
        })
        return children;
    }
}

export default ConfirmationLivestream;
